/**
 * Frontend configuration
 */

export const config = {
  apiUrl: process.env.REACT_APP_API_URL ?? 'http://localhost:3500',
};

export const storageKeys = {
  user: 'veraconnect.hr.user',
};